export enum MinutesEnum {
    cincoMinutos = 5,
}